<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && state && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <app-zaver-icon class="icon-user-img" [size]="80" name="phoneCircle"></app-zaver-icon>
      <h1 class="heading">Handynummer verifizieren</h1>
      <p class="info-text">Ein Verifizierungscode wurde gesendet&nbsp;an:</p>
      <div class="phone-number-wrapper">
        <span>{{ phoneNumberString }}</span>
        <div class="button-link-wrapper">
          <zaver-button-link [text]="'Ändern'" (click)="back()"></zaver-button-link>
        </div>
      </div>

      <div class="token-input-wrapper">
        <zaver-token-input
          (valueChange)="onOtpChange($event)"
          [showError]="showError"
          [isMobile]="isMobile"
          [IOS]="IOS"
          [maxLength]="otpLength"
        ></zaver-token-input>
      </div>

      <div class="display-error" *ngIf="showError">
        <img src="assets/icon/icon_error.svg" alt="" class="info-icon" />
        <p>Der Verifizierungscode ist falsch oder bereits&nbsp;abgelaufen</p>
      </div>

      <div class="resend-code" [ngClass]="showError ? 'error' : ''">
        <zaver-button-link
          [text]="'SMS erneut senden'"
          (click)="reSendCode()"
          [disabled]="navigationInProgress"
          [interactive]="true"
        ></zaver-button-link>
      </div>

      <div class="footer-wrapper">
        <div class="footer-container">
          <app-general-error
            *ngIf="!showError && noResponseError"
            class="general-error"
          ></app-general-error>

          <div class="button-container">
            <zaver-primary-button
              [buttonType]="'submit'"
              [formId]="'otp-input-form'"
              [text]="'Weiter'"
              [disabled]="navigationInProgress"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
